/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Typography from './Typography';

import styles from '../../styles/typography/document-subtitle.module.css';

const propTypes = {
    tag: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    tag: 'h4',
    className: null,
};

function DocumentSubtitle({ tag, className, ...props }) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        />
    );
}

DocumentSubtitle.propTypes = propTypes;
DocumentSubtitle.defaultProps = defaultProps;

export default DocumentSubtitle;
